<!--
 * Path: packages/frontend/src/features/browser/forms/datetime/DateTimeRead.vue
 * Task: Display formatted datetime strings.
-->
<template>
  <div class="d-flex align-center text-body-1 text-high-emphasis ms-1 mt-1">
    <v-icon size="small" color="medium-emphasis" class="me-2">mdi-calendar-clock</v-icon>
    <span>{{ formattedValue }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  modelValue?: string | null;
}>();

const formattedValue = computed(() => {
  if (!props.modelValue) return '-';
  const d = new Date(props.modelValue);
  if (isNaN(d.getTime())) return props.modelValue;
  return d.toLocaleString('de-DE', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit'
  });
});
</script>
